export async function selectAllNodes() {
    await this.execute(() => {
        const next = (chain) => {
            const {isFolded} = chain[0]
            const isHidden = this.isNodeHidden(chain[0])

            return {
                yieldChildren: ! (isFolded || isHidden),
                yieldNode: ! isHidden,
            }
        }

        const nodes = [...this.dfs(this.root, next)]
        this.selectNodes(nodes)
    })
}

export async function selectRoot() {
    await this.execute(
        () => this.selectNodes([this.root])
    )
}
